import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { procedureVersionDetail } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchProcedureVersionContent({
  account,
  fileId,
  snapshotTime,
}: TVariables): Promise<TResult> {
  const response = await fetch(
    procedureVersionDetail(account, fileId, snapshotTime),
    {
      method: 'GET',
      headers: {
        Authorization: getTokenWithType(),
      },
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSucess: boolean;
  StatusCode: number;
};

type TVariables = {
  account: number;
  fileId: string;
  snapshotTime: number | undefined;
};

function useGetProcedureVersionContent(
  account: number,
  fileId: string,
  snapshotTime: number | undefined,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_procedure_version_content', account, fileId, snapshotTime],
    async () => {
      if (fileId && snapshotTime)
        return await fetchProcedureVersionContent({
          fileId,
          account,
          snapshotTime,
        });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetProcedureVersionContent };
